import { motion } from "framer-motion";
import { Hourglass } from "lucide-react";
import { GATES, gateBroken, gateStacks } from "../../engine";
import { useGame } from "../../state/GameProvider";
import { Sfx } from "../../fx/sfx";
import { BattleLog } from "../shell/BattleLog";

export function CardHand() {
  const { state, actions } = useGame();
  const { duel } = state;
  const locked = duel.status === "won" || duel.status === "lost";

  return (
    <section className="cardzone" aria-label="攻勢牌組">
      <div className="cardhand">
        {GATES.map((gate, index) => {
          const broken = gateBroken(duel, gate.id);
          const active = duel.activeGate === gate.id && duel.status === "resolving";
          const stacks = gateStacks(duel, gate.id);
          return (
            <motion.button
              key={gate.id}
              type="button"
              className={`gatecard tone-${gate.id}${broken ? " broken" : ""}${active ? " active" : ""}`}
              initial={{ opacity: 0, y: 26, rotate: index % 2 ? 3 : -3 }}
              animate={{ opacity: 1, y: 0, rotate: 0 }}
              transition={{ delay: index * 0.06, type: "spring", stiffness: 220, damping: 22 }}
              whileHover={broken || locked ? undefined : { y: -8, scale: 1.03 }}
              whileTap={broken || locked ? undefined : { scale: 0.97 }}
              disabled={broken || locked}
              aria-label={`${gate.label} · ${gate.description} · ${stacks}/${gate.requirement}`}
              onClick={() => {
                Sfx.play();
                actions.play(gate.id);
              }}
            >
              <span className="gc-art" aria-hidden>
                {gate.glyph}
              </span>
              <span className="gc-name">{gate.cardName}</span>
              <span className="gc-tag">{gate.label}</span>
              <span className="gc-effect">{gate.effect}</span>
              {gate.condition && <span className="gc-cond">{gate.condition}</span>}
              <span className="gc-foot">
                <strong>{`${stacks}/${gate.requirement}`}</strong>
                <em>{broken ? "已破" : gate.buffLabel}</em>
              </span>
            </motion.button>
          );
        })}
      </div>

      <div className="manabar">
        <div className="mana-orbs" aria-label={`明點 ${duel.mana} / ${duel.maxMana}`}>
          {Array.from({ length: duel.maxMana }).map((_, k) => (
            <span key={k} className={`orb${k < duel.mana ? " full" : ""}`} />
          ))}
          <span className="mana-label">
            {`明點 ${duel.mana}/${duel.maxMana}`}
          </span>
        </div>
        <button className="endturn" onClick={actions.endTurn} disabled={locked}>
          <Hourglass size={14} />
          <span className="endturn-label">結束回合</span>
        </button>
      </div>

      <BattleLog compact />
    </section>
  );
}
